"use client";
import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { Monitor, Smartphone } from "lucide-react";
import CompactPortfolio from "./CompactPortfolio";
import Hero from "@/components/sections/Hero";
import { ClientTrustBadge } from "@/components/sections/ClientTrustBadge";
import { SectionDivider } from "@/components/ui/section-divider";
import { FloatingParticles } from "@/components/ui/floating-particles";

const About = dynamic(() => import("@/components/sections/About"));
const Projects = dynamic(() => import("@/components/sections/Projects"));
const Skills = dynamic(() => import("@/components/sections/Skills"));
const GitHubHeatmap = dynamic<{ initialData: any }>(
  () => import("@/components/sections/GitHubHeatmap")
);
const Experience = dynamic(() => import("@/components/sections/Experience"));
const Education = dynamic(() => import("@/components/sections/Education"));
const HireMe = dynamic(() => import("@/components/sections/HireMe"));
const Contact = dynamic<{ initialSpotifyData: any; data?: any }>(
  () => import("@/components/sections/Contact")
);

export default function HomeViewManager(props: any) {
  const [isCompact, setIsCompact] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("portfolio-view-compact");
    if (saved === "true") {
      setIsCompact(true);
    }
  }, []);

  const toggleView = () => {
    const newValue = !isCompact;
    setIsCompact(newValue);
    localStorage.setItem("portfolio-view-compact", String(newValue));
  };

  return (
    <>
      {/* Toggle Button */}
      <div className="fixed left-4 top-1/2 -translate-y-1/2 z-[100] flex flex-col gap-2">
        <button
          onClick={toggleView}
          className="p-3 rounded-full bg-neutral-900 border border-neutral-700 text-white shadow-xl hover:bg-neutral-800 transition-all group relative flex items-center justify-center hover:scale-110 active:scale-95"
        >
          {isCompact ? <Monitor size={20} /> : <Smartphone size={20} />}
          <span className="absolute left-14 px-2 py-1 bg-neutral-900 text-white text-xs font-medium rounded opacity-0 group-hover:opacity-100 whitespace-nowrap border border-neutral-700 pointer-events-none transition-opacity shadow-lg">
            {isCompact ? "Switch to Full View" : "Switch to Compact View"}
          </span>
        </button>
      </div>

      {isCompact ? (
        <CompactPortfolio {...props} />
      ) : (
        <main className="min-h-screen relative overflow-hidden flex justify-center w-full">
          <FloatingParticles />
          <div className="w-full max-w-7xl min-h-screen">
            <Hero data={props.hero} />
            <SectionDivider />
            <About data={props.about} />
            <SectionDivider />
            <Projects data={props.projects} blogs={props.blogs} />
            <ClientTrustBadge />
            <SectionDivider />
            <Skills data={props.skills} />
            <SectionDivider />
            <GitHubHeatmap initialData={props.githubData} />
            <SectionDivider />
            <Experience data={props.experience} />
            <SectionDivider />
            <Education data={props.education} />
            <SectionDivider />
            <HireMe data={props.hireMe} />
            <SectionDivider />
            <Contact data={props.contact} initialSpotifyData={props.spotifyData} />
          </div>
        </main>
      )}
    </>
  );
}
